import { TOOL_GROUPS, type Tool, type ToolGroupId } from '../../links/growthPlatformsLinks';
import { useTrackClick } from '../../usage/track';
import { LauncherTile } from './AppTile';
import { LAUNCHER_COPY as C } from './launcherCopy';

/**
 * One Hub tools tab's content: a single `TOOL_GROUPS` entry, rendered as its own
 * tab instead of a group inside one shared section. `tools` arrives already
 * searched; the group still renders when a search clears it out, with an
 * empty-state message, since the tab itself (not the whole section) is what the
 * group's visibility now hangs off.
 */
export function ToolGroupPanel({ tools, groupId }: { tools: readonly Tool[]; groupId: ToolGroupId }) {
  const group = TOOL_GROUPS.find((g) => g.id === groupId);
  const track = useTrackClick();
  const inGroup = tools.filter((t) => t.group === groupId);
  return (
    <div className="gp-fd-group-panel">
      <p className="gp-fd-sub">{group?.subtitle}</p>
      <p className="gp-fd-sub">{C.toolsNote}</p>
      {inGroup.length === 0 ? (
        <p className="gp-fd-empty-body">{C.toolsGroupEmpty}</p>
      ) : (
        // .gp-fd-grid sets list-style none, and Safari/VoiceOver drops list
        // semantics without an explicit role.
        <ul className="gp-fd-grid" role="list" aria-label={group?.title}>
          {inGroup.map((t) => (
            <li key={t.id}>
              <LauncherTile
                name={t.name}
                href={t.href}
                external
                category={t.category}
                blurb={t.blurb}
                onClick={() => track(`tool:${t.id}`)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
